function FileIcon(extension) {
    const extensionName = (extension + "").toLowerCase();
    if(['.jpg', '.jpeg', '.png', '.bmp', '.gif'].includes(extensionName))
        return <i className="fa-regular fa-file-image me-2 fa-fw"></i>;
    else if(['.xls', '.xlsx', '.csv'].includes(extensionName))
        return <i className="fa-regular fa-file-excel me-2 fa-fw"></i>;
    else if(['.doc', '.docx', '.page', 'txt', '.word'].includes(extensionName))
        return <i className="fa-regular fa-file-word me-2 fa-fw"></i>;
    else if(['.ppt', '.pptx'].includes(extensionName))
        return (<i className="fa-regular fa-file-powerpoint me-2 fa-fw"></i>);
    else if(['.pdf'].includes(extensionName))
        return (<i className="fa-regular fa-file-pdf me-2 fa-fw"></i>);
    else if(['.mp4', 'wmv', '.mkv', '.mov', '.avi', '.flv', '.webm', '.html5', '.mpeg', '.ogg', '.rmvb'].includes(extensionName))
        return (<i className="fa-regular fa-file-video me-2 fa-fw"></i>);
    else if(['.mp3', 'm4a', '.mka', '.ape', '.flac', '.aac', '.au', '.mid', '.midi'].includes(extensionName))
        return (<i className="fa-regular fa-file-audio me-2 fa-fw"></i>);
    else if(['.zip', '.rar', '.7z'].includes(extensionName))
        return (<i className="fa-regular fa-file-zipper me-2 fa-fw"></i>);
    else if(['.exe'].includes(extensionName))
        return (<i className="fa-solid fa-skull-crossbones me-2 fa-fw"></i>);
    else return (<i className="fa-regular fa-file me-2 fa-fw"></i>);
}
export default FileIcon;